import moment from "moment";
import { useEffect, useState } from "react";
import { Card, Col, Dropdown, Form, Jumbotron } from "react-bootstrap";
import { withTranslation } from "react-i18next";
import Get from "../../api/Get";
import { PARTNER_GET_ACTIVE, REPORTE_CITAS_PENDIENTE } from "../../api/Routes";
import DateInputFilter from "../DateInputFilter";
import TableSearch from "../TableSearch";
import ComponentModalErrorSever from '../../components/ComponentModalErrorSever'
import useCompanyType from "../../hook/useCompanyType";

function ReporteCitasPendientes({t, auth}){
    const [items, setItems] = useState([])
    const [loading, setLoading] = useState(false)
    const [startDate, setStartDate] = useState(new Date());
    const [endDate, setEndDate] = useState(new Date());
    const [partnerId, setPartnerId] = useState('')
    const [partnerOpt, setPartnerOpt] = useState([])

    //error
    const [showModalError, setShowModalError] = useState(false)
    const [errorServer, setErrorServer] = useState(null)
    const handleClose = () => setShowModalError(false)

    const companyType = useCompanyType()

    useEffect(()=>{
        if(endDate){
            let mounted = true
            setLoading(true)
            let url = `${REPORTE_CITAS_PENDIENTE}/0/9999/id/asc/${moment(startDate).format("DD-MM-YYYY")}/${moment(endDate).format("DD-MM-YYYY")}?partnerId=${partnerId}`
            Get({url: url, access_token: auth.data.access_token})
            .then(response=>{
                //console.log(response)
                if(mounted){
                    setItems(response.data.data.response.content)
                }
                setLoading(false)
            })
            .catch(error=>{
                setShowModalError(true)
                if(error.response){
                    setErrorServer(error.response)
                }
                setItems([])
                setLoading(false)
            })
            return () => mounted = false;
        }        
    }, [endDate, partnerId])

    useEffect(()=>{
        Get({url: PARTNER_GET_ACTIVE, access_token: auth.data.access_token})
        .then(response=>{            
            setPartnerOpt(response.data.data.response)
        })
        .catch(error=>{
            console.log(error)
        })
    }, [])

    const formatMinutsTranscurridos = (cell, row) => {
        let currentTime = moment(row.historicAppointment.createDate, "DD/MM/YYYY HH:mm:ss")
        let createdAt = moment(row.createdAt, "DD/MM/YYYY HH:mm:ss")
        let diffMinuts = currentTime.diff(createdAt, "m")
        return <span className={`badge align-minuts badge-light`}>{diffMinuts}</span>        
    }
    const formatFechaCreacion = (cell) => {
        return moment(cell, "DD/MM/YYYY HH:mm").format("DD/MM/YYYY HH:mm")
    }
    const formatFechaCita = cell => {
        return moment(cell, "YYYY-MM-DDTHH:mm:ss").format("DD-MM-YYYY HH:mm")
    }



    const columns = [
        {
          dataField: "id",
          text: "ID",
          hidden: true,
        },
        {
            dataField: 'createdAt',
            text: 'Fecha creación',
            headerStyle: { width: '10%' },
            formatter: formatFechaCreacion,
            editable: false  
        },
        {
            dataField: 'scheduleDTO.dateTimeInit',
            text: 'Fecha cita',
            headerStyle: { width: '10%' },
            formatter: formatFechaCita,  
            editable: false
        },
        {
            dataField: 'minuts',
            text: 'Minutos trans.',
            headerStyle: { width: '10%', textAlign: 'center' },
            style: {textAlign: 'center'},
            formatter: formatMinutsTranscurridos,
        },
        {
          dataField: "expediente",
          text: "Nro Expediente",
          headerStyle: { width: "15%" },
        },
        {
            dataField: 'patientDTO.account.name',
            text: 'Cliente corporativo',
            headerStyle: { width: '20%' },
        },        
        {
          dataField: "speciality.name",
          text: "Servicio",
          headerStyle: { width: "15%" },
        },
        {
          dataField: "historicAppointment.modifyByUser.name",
          text: "Usuario",
          headerStyle: { width: "20%" },
          formatter: cell => (cell ? cell : 'Sistema'),
        },
        {
            dataField: "token_conference",
            text: "Estatus",
            headerStyle: { width: "20%" },
            hidden: companyType !== "colombia",
            formatter: (cell, row) => (row.expediente ? "Gestionada" : 'No gestionada'),
        }, 
        {
            dataField: "historicAppointment.appointmentStatus",
            text: "ACCIÓN",
            style: {textAlign:'center'},
            headerStyle: { textAlign: 'center' },
            formatter: cell => (<span className={`badge ${cell==='Pagada' ? 'badge-success' : 'badge-danger'}`}>{cell}</span>),
          },
      ];



    return (
        <>
            <Card className="shadow-1">
                <Card.Body>
                <div className="d-flex align-items-center justify-content-between">
                    <div className="mr-5"><h6>Trazabilidad citas pendientes</h6></div>                                
                    <div>
                        <div className="d-flex align-items-center">
                            <div className="mr-2">
                                <DateInputFilter 
                                    startDate ={startDate} 
                                    setStartDate ={setStartDate}
                                    endDate ={endDate}
                                    setEndDate ={setEndDate}
                                />
                            </div>
                            <div>
                                <Form.Control 
                                    size="sm"
                                    as="select"
                                    className="form-control-sm"
                                    onChange={e=>setPartnerId(e.target.value)}
                                >
                                    <option value="">Seleccionar</option>
                                    {
                                        partnerOpt.map((item, i)=>(
                                            <option value={item.id} key={i}>{item.name}</option>
                                        ))
                                    }
                                </Form.Control>
                            </div>
                        </div>
                    </div>
                </div>
                <Dropdown.Divider />
                    {
                        loading && 
                        <Col xs="12" md="12">
                            <div className="text-center my-5">
                                <div className="spinner-border text-primary" role="status">
                                    <span className="sr-only">Loading...</span>
                                </div>
                            </div>
                        </Col>
                    }
                    {
                        (items.length === 0 && !loading) &&
                        <Col xs="12" md="12">
                            <Jumbotron>
                                <div className="text-center">
                                    <p className="m-0">No existe información a mostrar</p>
                                </div>
                            </Jumbotron>
                        </Col>                                    
                    }
                    {
                        (items.length > 0 && !loading) &&     
                        <Col xs="12" md="12">
                            <TableSearch columns={columns} items={items} className="th-text-uppercase" placeholderSearch="" />
                        </Col>
                    }  
                </Card.Body>
            </Card>
            <ComponentModalErrorSever 
                show={showModalError}
                handleClose={handleClose}
                error={errorServer}
            />
        </>
        
    )
}

export default withTranslation()(ReporteCitasPendientes)